import React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { TabNav, TabNavItem } from 'src/components/CustomersBar/CustomerTab/BankingTab/BankingTabItems.style';

type TransactionHistoryTabItemsRouteType =
    | 'deposit'
    | 'withdrawal'
    | 'manual-adjustment'
    | 'freebet-procedure';

export const BankingTabItems = observer((): JSX.Element | null => {
    const { routerBackoffice } = useAppStateContext();
    const customerParams = routerBackoffice.getParametersString('customers', 'tab.tab.tab') ?? 'deposit';

    const isTabActive = (label: string): boolean => {
        return customerParams === label;
    };

    interface MenuItems {
        id: TransactionHistoryTabItemsRouteType;
        label: string;
        onClick: () => void;
    }

    const menuItems: Array<MenuItems> = [
        {
            id: 'deposit',
            label: 'Deposit',
            onClick: (): void => routerBackoffice.redirectToCustomerBankingDeposit(),
        },
        {
            id: 'withdrawal',
            label: 'Withdrawal',
            onClick: (): void => routerBackoffice.redirectToCustomerBankingWithdrawal(),
        },
        {
            id: 'manual-adjustment',
            label: 'Manual adjustment',
            onClick: (): void => routerBackoffice.redirectToCustomerBankingManualAdjustment(),
        },
        {
            id: 'freebet-procedure',
            label: 'Free Bets',
            onClick: (): void => routerBackoffice.redirectToCustomerBankingFreebetProcedure(),
        }
    ];

    return (
        <TabNav>
            {menuItems.map(linkItem => (
                <TabNavItem
                    key={linkItem.id}
                    isActive={isTabActive(linkItem.id)}
                    onClick={linkItem.onClick}
                    data-test={`${linkItem.id}-tab`}
                >
                    {linkItem.label}
                </TabNavItem>
            ))}
        </TabNav>
    );
});
